
import { defineComponent, reactive, ref } from "vue";
import { useRouter } from "vue-router";
import { InfoMsg } from "@/constants/message.constant";
import { ElMessage } from "element-plus";
import { getMenteComment, updateMenteComment } from "@/api/menteComment.api";
import { MenteComment } from "@/interfaces/menteComment.interface";

export default defineComponent({
  setup() {
    const form = reactive({
      id: "",
      menteHyoujiFlg: false,
      menteComment: "",
    } as MenteComment);
    const updateBtnLoading = ref(false);
    const router = useRouter();

    // 画面情報セット
    // 情報セット
    const setDetailInfo = async () => {
      const {
        data: { result },
      } = await getMenteComment();
      form.id = result.id;
      form.menteHyoujiFlg = result.mente_hyouji_flg;
      form.menteComment = result.mente_comment;
      form.menteTitle = result.mente_title;
    };
    setDetailInfo();

    // 設定押下イベント
    const handleUpdate = async () => {
      updateBtnLoading.value = true;
      try {
        await updateMenteComment({
          menteComment: form.menteComment,
          menteHyoujiFlg: form.menteHyoujiFlg,
          menteTitle: form.menteTitle
        });
        ElMessage({
          type: "success",
          message: InfoMsg.INFO_MENTE_COMMENT_UPDATED,
        });
        updateBtnLoading.value = false;
      } catch (error) {
        updateBtnLoading.value = false;
      }
    };
    //キャンセルボタン押下
    const handleCancel = () => {
      router.back();
    };

    return {
      form,
      updateBtnLoading,
      handleUpdate,
      handleCancel,
    };
  },
});
